import { Tag } from 'antd'

import { ParticipateType } from '../../../../../../enums/ParticipateType'
import {
  AuctionMemberPageStatus,
  AuctionMemberPageStatusColorMap,
  AuctionMemberPageStatusEntrustTextMap,
  AuctionMemberPageStatusParticipantTextMap
} from '../../../enums/AuctionMemberPageStatus'

import { AuctionListStatusRenderProps } from './interface'

export const AuctionListStatusRender = ({
  record: { status = AuctionMemberPageStatus.WAIT_AUDIT, participateType }
}: AuctionListStatusRenderProps) => {
  const AuctionMemberStatusTextMap =
    participateType === ParticipateType.ENTRUST
      ? AuctionMemberPageStatusEntrustTextMap
      : AuctionMemberPageStatusParticipantTextMap

  return (
    <Tag color={AuctionMemberPageStatusColorMap[status]} variant='filled'>
      {AuctionMemberStatusTextMap[status]}
    </Tag>
  )
}
